<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-table mt-2">
        <div class="cardContentTableDiv" v-bind:class="[{
          'cardContentTableDY': client_name == 'DY',
          'cardContentTableMID': client_name == 'MID',
          'cardContentTableCRisk': client_name == 'CRISK',
        },]">
          <div class="card-header">
            <h3 class="card-title tableDashboardH3">
              {{ title }} <span>{{ subTitle }}</span>
            </h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <b-table class="table table-no-bordered " v-bind:class="[{
                    'doomYogaTable doomYogaDashboardTable': client_name == 'DY',
                    'irishDateTable irishDateDashboardTable': client_name == 'MID',
                    'cRiskTable cRiskDashboardTable': client_name == 'CRISK',
                  },]" :id="tableId" hover :items="rowsData" :fields="columns"></b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "DashboardTable",
  props: ["tableId", "title", "subTitle", "columns", "rowsData", "client_name"],
  data() {
    return {};
  },
  mounted() {
    // console.log(this.tableId);
    if (!$.fn.DataTable.isDataTable("#" + this.tableId)) {
      $("#" + this.tableId).DataTable({
        ordering: false,
        info: false,
        responsive: true,
        scrollY: "450px",
        scrollCollapse: true,
        searching: false,
        lengthChange: false,
        lengthMenu: [
          [5, 10, 25, 50, 100, -1],
          [5, 10, 25, 50, 100, "All"],
        ],
        // columns: this.$parent.columns,
        // data: this.$parent.rowsData,
        language: {
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
          },
        },
      });
    }
  },
  methods: {
    // getImgUrl(file_name) {
    //   var images = require.context(
    //     "@/assets/images/doom-yoga",
    //     false,
    //     /\.png$/
    //   );
    //   return images("./" + file_name + ".png");
    // },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/dashboard/Table.vue